import { Controller } from "@hotwired/stimulus"

// Copies a value (the approved projection's link) to the clipboard and says
// so on the button for a moment. The link also sits in a read-only input
// beside the button, so it can be selected by hand where the clipboard is
// blocked.
export default class extends Controller {
  static targets = ["source", "button"]

  async copy() {
    const label = this.buttonTarget.textContent
    try {
      await navigator.clipboard.writeText(this.sourceTarget.value)
      this.buttonTarget.textContent = "Copied"
    } catch {
      this.sourceTarget.select()
      this.buttonTarget.textContent = "Press Ctrl+C to copy"
    }
    clearTimeout(this.timer)
    this.timer = setTimeout(() => { this.buttonTarget.textContent = label }, 2000)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
